import config from '@config';

import createDataSource from '../createDataSource';

const BASE_PATHNAME = 'appearance';

export default () => {
  const dataSource = createDataSource(config.api.url);

  const get = () => dataSource.get(BASE_PATHNAME).json();
  const create = ({ values: json }) => dataSource.post(BASE_PATHNAME, { json }).json();
  const update = ({ values: json }) => dataSource.put(BASE_PATHNAME, { json }).json();
  const upsert = ({ hasBeenCreated, values }) => (hasBeenCreated ? update({ values }) : create({ values }));
  return {
    get,
    create,
    update,
    upsert,
  };
};
